import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import { BannerService } from '../../shared/services/banner.service';

import * as TyreReturnOrderActions from './tyre-return-order.action';
import { TyreReturnOrderService } from './tyre-return-order.service';
import { OrderService } from '../order/order.service';
import * as TyreReturnOrderModels from '../../models/tyre-return-order/tyre-return-order';
import * as OrderStatusModels from '../../models/order/orderStatus';
import { TyreReturnOrderSearchModel } from '../../models/tyre-return-order/tyre-return-orderSearch';

import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { saveAs } from 'file-saver';
import * as Models from '../../models/commonModels';
import { StorageService } from '../../shared/services/storage.service';


export interface TyreReturnOrderStateModel {
    OrderStatus: OrderStatusModels.OrderStatusListModel;
    OrderList: TyreReturnOrderModels.TyreReturnOrderListModel;
    Order: Models.Response<TyreReturnOrderModels.TyreReturnOrderModel>;
    Search: TyreReturnOrderSearchModel;
    FilteredReportLoading: number;

}

class DictionaryKeys {
  public static readonly OrderStatus = "TyreReturnOrderStatus";
}

@State<TyreReturnOrderStateModel>({
    name: 'tyreReturnOrderState',
    defaults: {
      OrderStatus: null,
      OrderList: null,
      Search: null,
      Order: null,
      FilteredReportLoading: null
    }
  })

  @Injectable()

  export class TyreReturnOrderState {
    constructor(
      private helperService: HelperService,
      private tyreReturnOrderService: TyreReturnOrderService,
      private orderService: OrderService,
      private bannerService: BannerService,
      private storageService: StorageService
  ) { }

  @Selector()
  static FilteredReportLoading(state: TyreReturnOrderStateModel) {
    return state.FilteredReportLoading;
  }

  @Selector()
  static OrderStatus(state: TyreReturnOrderStateModel) {
    return state.OrderStatus;
  }

  @Selector()
  static OrderList(state: TyreReturnOrderStateModel) {
    return state.OrderList;
  }

  @Selector()
  static Order(state: TyreReturnOrderStateModel) {
    return state.Order;
  }

  @Selector()
  static OrderSearch(state: TyreReturnOrderStateModel) {
    return state.Search;
  }

  @Action(TyreReturnOrderActions.GetList)
  GetList(
    context: StateContext<TyreReturnOrderStateModel>,
    action: TyreReturnOrderActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy zleceń wydania opon.';

    context.setState(
      patch({
        OrderList: null
      })
    );

    this.tyreReturnOrderService.getList(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            OrderList: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('TyreReturnOrderActions.GetList', error);

        this.bannerService.error(errorMessage);
      });
  }


  @Action(TyreReturnOrderActions.SetSearch)
  SetSearch(
    context: StateContext<TyreReturnOrderStateModel>,
    action: TyreReturnOrderActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreReturnOrderActions.GetList(action.Search));
  }

  @Action(TyreReturnOrderActions.SetListPage)
  SetListPage(
    context: StateContext<TyreReturnOrderStateModel>,
    action: TyreReturnOrderActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new TyreReturnOrderActions.GetList(action.Search));
  }

  @Action(TyreReturnOrderActions.ResetSearch)
  ResetSearch(
    context: StateContext<TyreReturnOrderStateModel>
  ) {

    const state = context.getState();

    const search = new TyreReturnOrderSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new TyreReturnOrderActions.GetList(search));
  }

  @Action(TyreReturnOrderActions.GetStatusDictionary)
  GetStatusDictionary(
    context: StateContext<TyreReturnOrderStateModel>
  ) {

    const errorMessage = 'Błąd pobierania statusów zleceń wydania opon.';

    let storageKey = DictionaryKeys.OrderStatus;

    context.setState(
      patch({
        OrderStatus: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.OrderStatus) {
      this.tyreReturnOrderService.getStatusDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              OrderStatus: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.helperService.SaveException('TyreReturnOrderActions.GetStatusDictionary', error);

          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(TyreReturnOrderActions.GetFilteredReport)
  GetFilteredReport(
      context: StateContext<TyreReturnOrderStateModel>,
      action: TyreReturnOrderActions.GetFilteredReport
   ) {
        function patchContext() {
          context.setState(
            patch ({
              FilteredReportLoading: Math.random()
            })
          );
        }

        const fileName = 'Raport-zlecenia-wydania';
        this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

        this.tyreReturnOrderService.getFilteredReport(action.Search).subscribe (
              res => {
                const file = new File([res], `${fileName}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(file);
                patchContext();
              },
              res => {
                patchContext();
                this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
              },
              () => {
                patchContext();
                this.helperService.consoleLog(' @Action(TyreReturnOrderActions.GetFilteredReport)');
              }
          );
  }

  @Action(TyreReturnOrderActions.DisposeSearch)
  DisposeSearch(
      context: StateContext<TyreReturnOrderStateModel>
    ) {

      context.setState(
        patch({
          Search: null
        }));
  }

  @Action(TyreReturnOrderActions.Set)
  Set(
    context: StateContext<TyreReturnOrderStateModel>,
    action: TyreReturnOrderActions.Set
  ) {
    const errorMessage = 'Błąd zapisu zmian zlecenia wydania opon.';

    this.tyreReturnOrderService.set(action.Order).subscribe(
      ret => {

        if (ret.Success) {
          this.bannerService.success('Zapisano zmiany do zlecenia wydania opon ' + ret.Item.Number + '.');

          context.setState(
            patch({
              Order: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('TyreReturnOrderActions.Set', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(TyreReturnOrderActions.Get)
  Get(
    context: StateContext<TyreReturnOrderStateModel>,
    action: TyreReturnOrderActions.Get
  ) {
    const errorMessage = 'Błąd odczytu szczegółów zlecenia wydania opon.';

    this.tyreReturnOrderService.get(action.OrderId).subscribe(
      ret => {

        if (ret.Success) {

          context.setState(
            patch({
              Order: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },

      (error) => {

        this.helperService.SaveException('TyreReturnOrderActions.Get', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }
}
